import { useQuery } from '@tanstack/react-query';
import { useApi } from '@mainstage/core-plugin-api';
import { panelCatalogApiRef } from '../api';

export const useFeatureRequest = (id: string) => {
  const panelCatalogApi = useApi(panelCatalogApiRef);

  return useQuery({
    queryKey: ['feature-requests', 'detail', id],
    queryFn: () => panelCatalogApi.fetchFeatureRequest(id),
    enabled: !!id,
  });
};
